import React from "react";
import { Send } from "lucide-react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

function Field({ label, name, value, onChange, type = "text", placeholder, required }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">
        {label}{required && " *"}
      </label>
      <Input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="mt-2 h-12 rounded-xl"
      />
    </div>
  );
}

export default function ContactForm({ form, submitting, onChange, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="lg:col-span-3 bg-white rounded-3xl border border-gray-100 p-8 lg:p-10 shadow-sm">
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Full Name" name="name" value={form.name} onChange={onChange} placeholder="Your name" required />
        <Field label="Email" name="email" type="email" value={form.email} onChange={onChange} placeholder="you@company.com" required />
        <Field label="Phone" name="phone" value={form.phone} onChange={onChange} placeholder="+91 " />
        <Field label="Service Interest" name="service" value={form.service} onChange={onChange} placeholder="e.g. BPO, HR Training" />
      </div>
      <div className="mt-5">
        <label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">Message *</label>
        <Textarea
          name="message"
          value={form.message}
          onChange={onChange}
          placeholder="How can we help you?"
          rows={5}
          className="mt-2 rounded-xl"
        />
      </div>
      <Button
        type="submit"
        disabled={submitting}
        className="mt-6 bg-brand hover:bg-brand-dark text-white rounded-full h-12 px-7 font-semibold"
      >
        {submitting ? (
          "Sending..."
        ) : (
          <span className="inline-flex items-center gap-2">Send Message <Send size={16} /></span>
        )}
      </Button>
    </form>
  );
}
